import * as React from "react";
import { Interactions } from "../core/providers/interactions.provider.tsx";
import { accentBtn, secondaryBtn } from "../shared/page-layout.ts";

export function FirstContactWidget() {
  const initial = [
    {
      id: "a",
      name: "Léa Moreau",
      phone: "06 12 34 56 78",
      source: "Doctolib",
      age: 34,
      when: "il y a 12min",
    },
    {
      id: "b",
      name: "Hugo Martin",
      phone: "07 98 76 54 32",
      source: "Téléphone",
      age: 45,
      when: "il y a 1h",
    },
  ];
  const [items, setItems] = React.useState(initial);
  const toast = Interactions.useToast();
  const dialog = Interactions.useDialog();
  const handleCall = (p: (typeof initial)[number]) => {
    toast.push({
      type: "info",
      title: `Appel de ${p.name}…`,
      message: p.phone,
    });
    setTimeout(() => {
      setItems((prev) => prev.filter((i) => i.id !== p.id));
      toast.push({ type: "success", title: "Contact traité" });
    }, 800);
  };
  const handleSchedule = (p: (typeof initial)[number]) => {
    dialog.openNewRdv(p.name);
    setItems((prev) => prev.filter((i) => i.id !== p.id));
  };
  return (
    <div className="flex flex-col gap-2">
      {items.map((p, i) => (
        <div
          key={i}
          className="rounded-md border border-sf-border bg-sf-surface-alt p-3"
        >
          <div className="mb-1 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="text-[13px] font-semibold">{p.name}</div>
              <span className="rounded border border-sf-border bg-white px-1.5 py-px text-[10.5px] font-semibold text-sf-text-muted">
                {p.source}
              </span>
            </div>
            <div className="text-[11px] text-sf-text-muted">{p.when}</div>
          </div>
          <div className="mb-2 text-xs text-sf-text-muted">
            {p.phone} · {p.age} ans
          </div>
          <div className="flex gap-1.5">
            <button
              type="button"
              onClick={() => handleCall(p)}
              className={accentBtn()}
            >
              Rappeler
            </button>
            <button
              type="button"
              onClick={() => handleSchedule(p)}
              className={secondaryBtn()}
            >
              Planifier RDV
            </button>
          </div>
        </div>
      ))}
      {items.length === 0 && (
        <div className="px-4 py-6 text-center text-xs text-sf-text-muted">
          Tous les contacts ont été traités ✨
        </div>
      )}
    </div>
  );
}

// --- Tâches / À faire ---
